import { BlacklistCurrenciesCurrencyCell } from './blacklist-currencies-currency-cell'
import { BlacklistCurrenciesUnhideCell } from './blacklist-currencies-unhide-cell'

import type { CurrencyModel, CurrencyRef } from '@root/entities/currency/model'
import type { Column } from '@root/shared/ui-kit'

export type BlacklistCurrenciesTableColumnId = 'currency' | 'action'

export const blacklistCurrenciesTableColumns: Array<
  Column<CurrencyModel | CurrencyRef.Ref, BlacklistCurrenciesTableColumnId>
> = [
  {
    id: 'currency',
    header: ({ t }) => t('token'),
    render: ({ value }) => <BlacklistCurrenciesCurrencyCell currency={value} />,
    minWidth: 200,
    width: '1fr',
  },
  {
    id: 'action',
    header: '',
    render: ({ value }) => <BlacklistCurrenciesUnhideCell currency={value} />,
    width: 60,
    justify: 'end',
  },
]
